// extracted by mini-css-extract-plugin
var _1 = "QB_ZZksW";
export { _1 as "fileHyperLink" }
